export class TariffDetailRevamp {
  constructor(
    condition,
    description,
    formula,
    geo_area,
    name,
    selected,
    inputs,
    amount,
  ) {
    this.condition = condition;
    this.description = description;
    this.formula = formula;
    this.geo_area = geo_area;
    this.name = name;
    this.selected = selected;
    this.inputs = inputs;
    this.amount = amount;
  }
  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      return new TariffDetailRevamp(
        input.condition,
        input.description,
        input.formula,
        input.geo_area || [],
        input.name,
        input.selected,
        input.inputs,
        input.amount,
      );
    }
    return new TariffDetailRevamp();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => TariffDetailRevamp.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [TariffDetailRevamp.fromApiObject(input)];
    }
    return [];
  }
}